// extracted by mini-css-extract-plugin
export default {"shell":"contact_shell__SK0tK","shellMobile":"contact_shellMobile__01Ki9","h2":"contact_h2__QM4Db"};